import SidebarFooter from "../menu/SidebarFooter";
import ItensMenu from "../menu/ItensMenu";
import useResponsiveSidebar from "../menu/useResponsiveSidebar";
import { useLocation } from "react-router-dom";
import "../menu/Sidebar.css";
export default function MrvSidebar({ close }) {
 const location = useLocation();
 const { isMobile, mobileOpen, sidebarRef, closeMobileSidebar } = useResponsiveSidebar(close, location.pathname);
 return <aside ref={sidebarRef} className={`sidebar ${close ? "collapsed" : ""} ${isMobile && mobileOpen ? "mobile-open" : ""}`}>
 <button type="button" className="mobile-sidebar-close" onClick={closeMobileSidebar} aria-label="Fechar menu">×</button>
 <div className="sidebar-header"><div className="logo-circle"><img src="/favicon.png" alt="Smart Olfativos" /></div><div className="sidebar-title-text"><div className="sidebar-title-1">Portal MRV</div><div className="sidebar-title-2">Smart Olfativos</div></div></div>
 <nav className="sidebar-menu">
   <ItensMenu nome="Pedidos" icone="📦" link="/mrv/pedidos" active={location.pathname === "/mrv/pedidos" || location.pathname === "/mrv/dashboard" ? "active" : ""} />
   <ItensMenu nome="Incluir novo pedido" icone="＋" link="/mrv/pedidos/novo" active={location.pathname.endsWith("/novo") ? "active" : ""} />
   <ItensMenu nome="Meu perfil" icone="👤" link="/meus-dados" active={location.pathname === "/meus-dados" ? "active" : ""} />
   <ItensMenu nome="Alterar senha" icone="🔑" link="/alterar-senha" active={location.pathname === "/alterar-senha" ? "active" : ""} />
 </nav><SidebarFooter /></aside>;
}
